import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "../Common";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

import logoLightSmallSvg from "../../assets/images/logo-light-small.svg";
import logoLightSvg from "../../assets/images/logo-light.svg";
import ftxWireframeSvg from "../../assets/svg/ftx-wireframe.svg";

const Sidebar = props => (
    <div className="vertical-menu">
        <div className="navbar-brand-box">
            <Link to="/" className="logo logo-light">
            <span className="logo-sm ">
              <img src={logoLightSmallSvg} alt="" height="19" />
            </span>
                <span className="logo-lg">
              <img src={logoLightSvg} alt="" height="50" />
            </span>
            </Link>
        </div>
        <div data-simplebar className="h-100">
            {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background">
          <img src={ftxWireframeSvg} alt=""  />
        </div>
    </div>
);

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
